import React from "react";

function MobileOnlyWarning()
{
    return (
        <div className="mobileWarning">
            <p>epIMS analyses data collected from your EPCs and is best experienced on a desktop browser to unlock its full potential.</p>
        </div>
    )
}

export default MobileOnlyWarning;